/* lb-desktop-dropdown-hover.js
   Desktop hover dropdown for Dawn disclosure menu (non-mega)
   + mega-style animation classes: lb-dd-opening / lb-dd-open / lb-dd-closing

   Works when your dropdown structure is:
   <header-menu>
     <details>
       <summary>...</summary>
       <ul class="header__submenu ...">...</ul>
     </details>
   </header-menu>
*/

(function () {
  const MQ = window.matchMedia("(min-width: 1025px)");

  // Match CSS timings
  const OPEN_DELAY = 0;      // ms
  const CLOSE_DELAY = 90;    // ms (prevents flicker when moving into submenu)
  const DURATION_MS = 340;   // ms (match CSS transform transition)

  let destroy = null;

  function directChild(details, selector) {
    return Array.from(details.children).find((el) => el.matches(selector)) || null;
  }

  function getDropdowns() {
    const all = Array.from(
      document.querySelectorAll(".header__inline-menu header-menu details")
    );

    // Keep only details that have a direct <summary> and direct <ul.header__submenu>
    return all.filter((d) => directChild(d, "summary") && directChild(d, "ul.header__submenu"));
  }

  function clearTimers(d) {
    if (d._lbCloseTimer) {
      clearTimeout(d._lbCloseTimer);
      d._lbCloseTimer = null;
    }
    if (d._lbDoneTimer) {
      clearTimeout(d._lbDoneTimer);
      d._lbDoneTimer = null;
    }
    if (d._lbOpenTimer) {
      clearTimeout(d._lbOpenTimer);
      d._lbOpenTimer = null;
    }
  }

  function clearState(d) {
    d.classList.remove("lb-dd-opening", "lb-dd-open", "lb-dd-closing");
  }

  function closeImmediate(d) {
    clearTimers(d);
    clearState(d);
    d.removeAttribute("open");
  }

  function closeAllImmediate(except = null) {
    getDropdowns().forEach((x) => {
      if (except && x === except) return;
      closeImmediate(x);
    });
  }

  function closeAnimated(d) {
    if (!d.hasAttribute("open")) return;

    clearTimers(d);
    d.classList.remove("lb-dd-open", "lb-dd-opening");
    d.classList.add("lb-dd-closing");

    // After animation, actually close <details>
    d._lbDoneTimer = setTimeout(() => {
      d.removeAttribute("open");
      d.classList.remove("lb-dd-closing");
      d._lbDoneTimer = null;
    }, DURATION_MS + 80);
  }

  function openAnimated(d) {
    clearTimers(d);

    // Prevent stacking
    closeAllImmediate(d);

    clearState(d);
    d.classList.add("lb-dd-opening");
    d.setAttribute("open", "");

    // force reflow so transition consistently triggers
    void d.offsetHeight;

    // next frame -> open state (animates in)
    requestAnimationFrame(() => {
      if (!d.matches(":hover")) return;
      d.classList.remove("lb-dd-opening");
      d.classList.add("lb-dd-open");
    });
  }

  function enable() {
    const list = getDropdowns();
    if (!list.length) return () => {};

    // Reset state
    list.forEach(closeImmediate);

    const cleanups = [];

    list.forEach((d) => {
      const summary = directChild(d, "summary");
      if (!summary) return;

      // Hover-only on desktop: prevent click toggling
      const onSummaryClick = (e) => e.preventDefault();

      const onEnter = () => {
        clearTimers(d);
        d._lbOpenTimer = setTimeout(() => openAnimated(d), OPEN_DELAY);
      };

      const onLeave = (e) => {
        // If moving into submenu, don't close
        if (d.contains(e.relatedTarget)) return;

        clearTimers(d);
        d._lbCloseTimer = setTimeout(() => {
          if (!d.matches(":hover")) closeAnimated(d);
        }, CLOSE_DELAY);
      };

      summary.addEventListener("click", onSummaryClick);
      d.addEventListener("mouseenter", onEnter);
      d.addEventListener("mouseleave", onLeave);

      cleanups.push(() => {
        clearTimers(d);
        clearState(d);
        d.removeAttribute("open");
        summary.removeEventListener("click", onSummaryClick);
        d.removeEventListener("mouseenter", onEnter);
        d.removeEventListener("mouseleave", onLeave);
      });
    });

    // Close on outside click
    const onOutside = (e) => {
      const inside = e.target.closest(".header__inline-menu header-menu details");
      if (!inside) list.forEach(closeAnimated);
    };
    document.addEventListener("pointerdown", onOutside);
    cleanups.push(() => document.removeEventListener("pointerdown", onOutside));

    // Close on ESC
    const onEsc = (e) => {
      if (e.key === "Escape") list.forEach(closeAnimated);
    };
    document.addEventListener("keydown", onEsc);
    cleanups.push(() => document.removeEventListener("keydown", onEsc));

    return () => cleanups.forEach((fn) => fn());
  }

  function disable() {
    if (destroy) {
      destroy();
      destroy = null;
    }
    getDropdowns().forEach(closeImmediate);
  }

  function sync() {
    if (MQ.matches) {
      if (!destroy) destroy = enable();
    } else {
      disable(); // back to default click behavior on <=1024
    }
  }

  MQ.addEventListener?.("change", sync);
  sync();
})();
